import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Favicon from 'react-favicon';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import Loading from './components/Loading';
import PrivateRoute from './components/PrivateRoute';
import { API_HOST } from './consts';
import MainSection from './containers/global/MainSection';
import { ThemeContext } from './contexts/ThemeContext';
import StudentAnalysis from './pages/avalia/StudentAnalysis';
import HeadQuartersPage from './pages/avalia/HeadQuartersPage';
import ProficiencyScalePage from './pages/avalia/ProficiencyScalePage';
import RelatorioTurma from './pages/avalia/RelatorioTurma';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import Login from './pages/Login';
import LoginRedirect from './pages/LoginRedirect';
import TokenLogin from './pages/TokenLogin';
import defaultTheme from './theme/DefaultTheme';
import withTracker from './withTracker';
import FiltersPageRelatorio from './pages/avalia/FiltersPageRelatorio';
import FiltersPageSelfStudent from './pages/avalia/FiltersPageAlunoSelf';
import FiltersPageAluno from './pages/avalia/FiltersPageAluno';
import FiltersPageHabilidade from './pages/avalia/FiltersPageHabilidade';
import InstitutionSelectionPage from './pages/InstitutionSelectionPage';
import ExternalAuthPage from './pages/ExternalAuthPage';
import ExternalAuthPagePae from './pages/ExternalAuthPagePae';
import ReportStudentSkillLevel from './pages/avalia/ReportStudentSkillLevel';
import ProficienciaLineChart from './pages/avalia/ProficienciaLineChart';
import PlanReport from './pages/relatorio/PlanReport';
import ReportClass from './pages/avalia/ReportClass';
import ProviderLogin from './pages/external_auth/ProviderLogin';
import ExternalLogin from './pages/external_auth/ExternalLogin';
import InitializeGoogleAnalytics from './utils/googleAnalytics';
import LoginPortal from './pages/LoginPortal';
import ExternalAuthV3Page from './pages/ExternalAuthV3Page';

const App = () => {
  useEffect(() => {
    InitializeGoogleAnalytics();
  });

  const [loadingTheme, setLoadingTheme] = useState(true);
  const [theme, setTheme] = useState({});

  const fetchTheme = async () => {
    try {
      const response = await axios.get(`${API_HOST}/themes/`);
      setTheme({
        ...defaultTheme,
        ...response.data.theme
      });
      setLoadingTheme(false);
    } catch (e) {
      setLoadingTheme(false);
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  if (loadingTheme) {
    return <Loading />;
  }

  return (
    <BrowserRouter>
      <ThemeContext.Provider value={theme}>
        <ThemeProvider theme={theme}>
          <div>
            <Route
              path="/external-provider/provider/:provider/token/:token/avaliacao_id/:avaliacao_id"
              component={ProviderLogin}
            />
            <Route
              path="/external-login/provider/:provider/token/:token"
              component={ExternalLogin}
            />
            <Favicon url={theme.favicon} />
            <ToastContainer autoClose={10000} />
            <Switch>
              <Route
                path="/external-auth-v3/:token/:redirect"
                component={ExternalAuthV3Page}
              />
              <Route
                path="/external-auth/:provider"
                component={ExternalAuthPage}
              />
              <Route
                path="/external-auth-pae/:provider"
                component={ExternalAuthPagePae}
              />

              <Route
                path="/aluno-acertos/:id"
                component={ReportStudentSkillLevel}
              />

              <Route path="/login" component={LoginPortal} />

              <Route
                path="/login-redirect"
                component={withTracker(LoginRedirect)}
              />
              <Route path="/aluno/:id" component={StudentAnalysis} />
              <Route
                path="/filter-aluno-disciplina"
                component={FiltersPageSelfStudent}
              />
              <Route path="/relatorio-meu/:id" component={StudentAnalysis} />

              <Route
                path="/filters-distribuicao-proficiencia"
                component={FiltersPageRelatorio}
              />
              {/* <Route path="/filters-aluno" component={FiltersPageAluno} /> */}
              <Route
                path="/filters-nivel-habilidade"
                component={FiltersPageHabilidade}
              />
              <Route
                path="/nivel-habilidade/:disciplinaId/escola/:escolaId/etapa/:etapaId"
                component={HeadQuartersPage}
              />
              <PrivateRoute
                path="/escolher-instituicao"
                component={InstitutionSelectionPage}
              />
              <Route
                path="/relatorio-turma/:id/etapa/:etapaId/disciplina/:disciplinaId"
                component={RelatorioTurma}
              />
              {/* <Route
                path="/relatorio-da-turma/:id/turma/:cdTurma/disciplina/:disciplinaId"
                component={ReportClass}
              /> */}
              <Route
                path="/distribuicao-proficiencia-aluno/:escolaId/disciplina/:discId"
                component={ProficiencyScalePage}
              />
              <Route
                path="/token-login/:token"
                component={withTracker(TokenLogin)}
              />
              <Route
                path="/forgot-password"
                component={withTracker(ForgotPassword)}
              />
              <Route
                path="/password-reset/:token"
                component={withTracker(ChangePassword)}
              />
              <Route
                path="/report-proficiencia"
                component={ProficienciaLineChart}
              />

              <MainSection />
            </Switch>
          </div>
        </ThemeProvider>
      </ThemeContext.Provider>
    </BrowserRouter>
  );
};

export default App;
